import { Outlet } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import AlertWarning from "@/components/AlertWarning";
import { useUser } from "./../../features/authentication/hooks/useUser";

function AppLayout() {
    const { isActive, isPending, isAuthenticated } = useUser();

    return (
        <div className="min-h-dvh w-full bg-background-color grid grid-rows-[auto,1fr,auto]">
            {isAuthenticated && !isActive && !isPending && <AlertWarning />}
            <Header />
            <main className="min-h-dvh ">
                <Outlet />
            </main>
            {/* <div className="relative py-20 bg-background-color -mt-[7rem] top-28"></div> */}
            <Footer />
        </div>
    );
}

export default AppLayout;
